module.exports = __webpack_public_path__ + "static/roboto-v29-latin-regular-aa23b7b4bcf2b8f0e876106bb3de69c6.woff2";